import { Injectable } from '@angular/core';
import { MemberLevel } from '../../customerservice/common/enumerations';
import { MemberTypeId } from '../../customerservice/constants/member-type-id.enum';
import { PortalDisplayPage } from '../../customerservice/constants/portal-display-page.enum';
import { CommonService } from '../../shared/services/common.service';
import { AppCountryConfig } from '../../customerservice/interface/app-config';
import { CacheService } from './cache.service';
import { CacheKey } from '../constants/cachekey.constants';
import { AppConfigService } from '../../customerservice/services/app-config.service';
import { DisplayPriceConfig } from '../interface/display-price-config.interface';
import { Member } from '../interface/member.interface';

@Injectable()
export class MemberDisplayPriceConfigService {

    enableWHLSAL00ForAsstSupervisor: boolean;
    appConfigSetting:AppCountryConfig;
    constructor(private _commonService: CommonService, private _appConfigService: AppConfigService,) {
        
    }

    /**
     *
     */
    private getApplicablePriceConfig(displayPage: number, taxInclusiveStore: boolean,
        userInfo: Member, taxCalculated: boolean, taxInclusiveShippingCountry: boolean,
        enableVATCalculation: Boolean,isjoinFbo?:boolean): boolean {
        let displayApplicablePrice = true;
        if (!enableVATCalculation && taxInclusiveStore) {
            if (this.appConfigSetting && this.appConfigSetting.enableVatItemizationForNonVat) {
                if ((userInfo && userInfo.memberTypeId===MemberTypeId.DISTRIBUTOR) || isjoinFbo) {
                    if((userInfo && userInfo.vatRegistered) || isjoinFbo){
                        displayApplicablePrice = false;
                    }else if(taxCalculated){
                        displayApplicablePrice = false;
                    }else{
                        displayApplicablePrice = true;
                    }
                }else{
                    displayApplicablePrice = true;
                }
            } else {
                if(taxCalculated){
                    displayApplicablePrice = false;
                }
            }        
            return displayApplicablePrice;
        }
        const vatRegistered = userInfo ? userInfo.vatRegistered : false;
        if (userInfo && userInfo.memberTypeId === MemberTypeId.DISTRIBUTOR  
            && this.enableWHLSAL00ForAsstSupervisor
            && taxInclusiveStore) {
            if (displayPage === PortalDisplayPage.PlaceOrder) {
                if (taxInclusiveShippingCountry && vatRegistered && !taxCalculated) {
                    displayApplicablePrice = true;
                } else if (taxInclusiveShippingCountry && vatRegistered && taxCalculated) {
                    displayApplicablePrice = false;
                } else if (taxInclusiveShippingCountry && !vatRegistered
                    && (!userInfo.transactionalWholesaleQualified || !userInfo.transactionalOptin)) {
                    displayApplicablePrice = true;
                } else if (taxInclusiveShippingCountry && !vatRegistered) {
                    displayApplicablePrice = false;
                } else if (!taxInclusiveShippingCountry) {
                    displayApplicablePrice = false;
                }
            } else if (displayPage === PortalDisplayPage.ProductDetail ||
                displayPage === PortalDisplayPage.ShoppingCart) {
                if (vatRegistered) {
                    displayApplicablePrice = true;
                } else if (!vatRegistered && (!userInfo.transactionalWholesaleQualified || !userInfo.transactionalOptin)) {
                    displayApplicablePrice = true;
                } else if (!vatRegistered) {
                    displayApplicablePrice = false;
                } else {
                    displayApplicablePrice = true;
                }
            } else {
                displayApplicablePrice = true;
            }
        } else if (taxInclusiveStore) {
            if ((!taxInclusiveShippingCountry || (taxInclusiveShippingCountry
                && vatRegistered && taxCalculated)) && (displayPage === PortalDisplayPage.PlaceOrder)) {
                displayApplicablePrice = false;
            } else {
                displayApplicablePrice = true;
            }
        } else {
            displayApplicablePrice = true;
        }
        return displayApplicablePrice;
    }

    /**
    *
    */
    private getCatalogPriceConfig(displayPage: number, taxInclusiveStore: boolean,
        userInfo: Member, taxCalculated: boolean, taxInclusiveShippingCountry: boolean,
        enableVATCalculation: Boolean,isjoinFbo?:boolean): boolean {
        let displayCatalogPrice = false;
        if (!enableVATCalculation && taxInclusiveStore) {
            if (this.appConfigSetting && this.appConfigSetting.enableVatItemizationForNonVat) {
                if ((userInfo && userInfo.memberTypeId===MemberTypeId.DISTRIBUTOR) ||isjoinFbo) {
                    if((userInfo && userInfo.vatRegistered) || isjoinFbo){
                        displayCatalogPrice = true;
                    }else if(taxCalculated){
                        displayCatalogPrice = true;
                    }else{
                        displayCatalogPrice = false;
                    }
                }else{
                    displayCatalogPrice = false;
                }
            }
            else{
                if (taxCalculated) {
                    displayCatalogPrice = true;
                }
            }
            return displayCatalogPrice;
        }
        const vatRegistered = userInfo ? userInfo.vatRegistered : false;
        if (userInfo && userInfo.memberTypeId === MemberTypeId.DISTRIBUTOR
            && this.enableWHLSAL00ForAsstSupervisor
            && taxInclusiveStore) {
            if (displayPage === PortalDisplayPage.PlaceOrder) {
                if (taxInclusiveShippingCountry && vatRegistered && !taxCalculated) {
                    displayCatalogPrice = false;
                } else if (taxInclusiveShippingCountry && vatRegistered && taxCalculated) {
                    displayCatalogPrice = true;
                } else if (!taxInclusiveShippingCountry) {
                    displayCatalogPrice = true;
                }
            } else {
                displayCatalogPrice = false;
            }
        } else if (taxInclusiveStore) {
            if ((!taxInclusiveShippingCountry || (taxInclusiveShippingCountry
                && vatRegistered && taxCalculated)) && (displayPage === PortalDisplayPage.PlaceOrder)) {
                displayCatalogPrice = true;
            } else {
                displayCatalogPrice = false;
            }
        } else {
            displayCatalogPrice = false;
        }
        return displayCatalogPrice;
    }

    /**
     *
     */
    private getComputedTaxInclusivePriceConfig(displayPage: number, taxInclusiveStore: boolean,
        userInfo: Member, taxCalculated: boolean, taxInclusiveShippingCountry: boolean,
        enableVATCalculation: Boolean): boolean {
        let displayComputedTaxInclusivePrice = false;
        if (!enableVATCalculation && taxInclusiveStore) {
            return displayComputedTaxInclusivePrice;
        }
        const vatRegistered = userInfo ? userInfo.vatRegistered : false;
        if (userInfo && userInfo.memberTypeId === MemberTypeId.DISTRIBUTOR
            && this.enableWHLSAL00ForAsstSupervisor
            && userInfo.transactionalWholesaleQualified && userInfo.transactionalOptin
            && taxInclusiveStore) {
            if (displayPage === PortalDisplayPage.PlaceOrder) {
                if (taxInclusiveShippingCountry && !vatRegistered) {
                    displayComputedTaxInclusivePrice = true;
                } else if (!taxInclusiveShippingCountry) {
                    displayComputedTaxInclusivePrice = false;
                } else if (vatRegistered) {
                    displayComputedTaxInclusivePrice = false;
                }
            } else {
                displayComputedTaxInclusivePrice = false;
            }
        } else {
            displayComputedTaxInclusivePrice = false;
        }
        return displayComputedTaxInclusivePrice;
    }

    /**
    *
    */
    private getRetailPriceConfig(displayPage: number, taxInclusiveStore: boolean,
        userInfo: Member, taxCalculated: boolean, taxInclusiveShippingCountry: boolean,
        enableVATCalculation: Boolean,isjoinFbo?:boolean): boolean {
        let displayRetailPrice = true;
        if (!enableVATCalculation && taxInclusiveStore) {      
            if (this.appConfigSetting && this.appConfigSetting.enableVatItemizationForNonVat) {
                if ((userInfo && userInfo.vatRegistered) ||isjoinFbo) {
                    displayRetailPrice = false;
                } else{
                    displayRetailPrice = true;
                }
            }          
            else{ 
                displayRetailPrice = true;
            }      
            return displayRetailPrice;
        }
        const vatRegistered = userInfo ? userInfo.vatRegistered : false;
        if (userInfo && userInfo.memberTypeId === MemberTypeId.DISTRIBUTOR  
            && userInfo.transactionalWholesaleQualified && userInfo.transactionalOptin
            && taxInclusiveStore) {
            if (displayPage === PortalDisplayPage.PlaceOrder) {
                if (taxInclusiveShippingCountry && vatRegistered) {
                    displayRetailPrice = false;
                } else if (!taxInclusiveShippingCountry && vatRegistered) {
                    displayRetailPrice = false;
                } else if (taxInclusiveShippingCountry && !vatRegistered) {
                    displayRetailPrice = true;
                } else if (!taxInclusiveShippingCountry) {
                    displayRetailPrice = true;
                }
            } else {
                displayRetailPrice = true;
            }
        } else {
            displayRetailPrice = true;
        }
        return displayRetailPrice;
    }

    /**
    *
    */
    private getBaseRetailPriceConfig(displayPage: number, taxInclusiveStore: boolean,
        userInfo: Member, taxCalculated: boolean, taxInclusiveShippingCountry: boolean,
        enableVATCalculation: Boolean,isjoinFbo?:boolean): boolean {
        let displayBaseRetailPrice = false;
        if (!enableVATCalculation && taxInclusiveStore) {
            if (this.appConfigSetting && this.appConfigSetting.enableVatItemizationForNonVat) {
                if ((userInfo && userInfo.vatRegistered) || isjoinFbo) {
                    displayBaseRetailPrice = true;
                } else{
                    displayBaseRetailPrice = false;
                }
            }  
            return displayBaseRetailPrice;
        }
        const vatRegistered = userInfo ? userInfo.vatRegistered : false;
        if (userInfo && userInfo.memberTypeId === MemberTypeId.DISTRIBUTOR 
            && userInfo.transactionalWholesaleQualified && userInfo.transactionalOptin
            && taxInclusiveStore) {
            if (displayPage === PortalDisplayPage.PlaceOrder) {
                if (taxInclusiveShippingCountry && vatRegistered) {
                    displayBaseRetailPrice = true;
                } else if (!taxInclusiveShippingCountry && vatRegistered) {
                    displayBaseRetailPrice = true;
                } else if (taxInclusiveShippingCountry && !vatRegistered) {
                    displayBaseRetailPrice = false;
                } else if (!taxInclusiveShippingCountry) {
                    displayBaseRetailPrice = false;
                }
            } else {
                displayBaseRetailPrice = false;
            }
        } else {
            displayBaseRetailPrice = false;
        }
        return displayBaseRetailPrice;
    }


    /**
    *
    */
    private getWholesalePriceConfig(displayPage: number, taxInclusiveStore: boolean,
        userInfo: Member, taxCalculated: boolean, taxInclusiveShippingCountry: boolean,
        enableVATCalculation: Boolean,isjoinFbo?:boolean): boolean {
        let displayWholesalePrice = true;
        if (!enableVATCalculation && taxInclusiveStore) {
            if (this.appConfigSetting && this.appConfigSetting.enableVatItemizationForNonVat) {
                if ((userInfo && userInfo.vatRegistered) ||isjoinFbo ) {
                    displayWholesalePrice = false;
                } else{
                    displayWholesalePrice = true;
                }
            } 
            return displayWholesalePrice;
        }
        const vatRegistered = userInfo ? userInfo.vatRegistered : false;
        if (userInfo && userInfo.memberTypeId === MemberTypeId.DISTRIBUTOR 
            && userInfo.transactionalWholesaleQualified && userInfo.transactionalOptin
            && taxInclusiveStore) {
            if (displayPage === PortalDisplayPage.PlaceOrder) {
                if (taxInclusiveShippingCountry && vatRegistered) {
                    displayWholesalePrice = false;
                } else if (!taxInclusiveShippingCountry && vatRegistered) {
                    displayWholesalePrice = false;
                } else if (taxInclusiveShippingCountry && !vatRegistered) {
                    displayWholesalePrice = true;
                } else if (!taxInclusiveShippingCountry) {
                    displayWholesalePrice = true;
                }
            } else {
                displayWholesalePrice = true;
            }
        } else {
            displayWholesalePrice = true;
        }
        return displayWholesalePrice;
    }

    /**
    *
    */
    private getBaseWholesalePriceConfig(displayPage: number, taxInclusiveStore: boolean,
        userInfo: Member, taxCalculated: boolean, taxInclusiveShippingCountry: boolean,
        enableVATCalculation: Boolean,isjoinFbo?:boolean): boolean {
        let displayBaseWholesalePrice = false;
        if (!enableVATCalculation && taxInclusiveStore) {
            if (this.appConfigSetting && this.appConfigSetting.enableVatItemizationForNonVat) {
                if ((userInfo && userInfo.vatRegistered) ||isjoinFbo) {
                    displayBaseWholesalePrice = true;
                } else{
                    displayBaseWholesalePrice = false;
                }
            }  
            return displayBaseWholesalePrice;
        }
        const vatRegistered = userInfo ? userInfo.vatRegistered : false;
        if (userInfo && userInfo.memberTypeId === MemberTypeId.DISTRIBUTOR
            && userInfo.transactionalWholesaleQualified && userInfo.transactionalOptin
            && taxInclusiveStore) {
            if (displayPage === PortalDisplayPage.PlaceOrder) {
                if (taxInclusiveShippingCountry && vatRegistered) {
                    displayBaseWholesalePrice = true;
                } else if (!taxInclusiveShippingCountry && vatRegistered) {
                    displayBaseWholesalePrice = true;
                } else if (taxInclusiveShippingCountry && !vatRegistered) {
                    displayBaseWholesalePrice = false;
                } else if (!taxInclusiveShippingCountry) {
                    displayBaseWholesalePrice = false;
                }
            } else {
                displayBaseWholesalePrice = false;
            }
        } else {
            displayBaseWholesalePrice = false;
        }
        return displayBaseWholesalePrice;
    }

    /**
    *
    */
    getDisplayPriceConfig(displayPage: number, taxInclusiveStore: boolean,
        userInfo: Member, taxCalculated: boolean, taxInclusiveShippingCountry: boolean, storeISOCodeThree: string,
        enableVATCalculation: Boolean,isJoinFbo?:boolean): DisplayPriceConfig {
        this.appConfigSetting = this._appConfigService.getSettings(storeISOCodeThree, userInfo);
        const isWHLSAL00EnabledForAsstSupervisor = this._commonService.isWHLSAL00enabledForAsstSupervisor(storeISOCodeThree);
        this.enableWHLSAL00ForAsstSupervisor = userInfo && (userInfo.memberTitleId > MemberLevel.ASSISTANTSUPERVISOR
            || (userInfo.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR
                && isWHLSAL00EnabledForAsstSupervisor)) ? true : false;
        const displayPriceConfig: DisplayPriceConfig = {
            displayApplicablePrice: this.getApplicablePriceConfig(displayPage, taxInclusiveStore,
                userInfo, taxCalculated, taxInclusiveShippingCountry, enableVATCalculation,isJoinFbo),
            displayCatalogPrice: this.getCatalogPriceConfig(displayPage, taxInclusiveStore,
                userInfo, taxCalculated, taxInclusiveShippingCountry, enableVATCalculation,isJoinFbo),
            displayRetailPrice: this.getRetailPriceConfig(displayPage, taxInclusiveStore,
                userInfo, taxCalculated, taxInclusiveShippingCountry, enableVATCalculation,isJoinFbo),
            displayBaseRetailPrice: this.getBaseRetailPriceConfig(displayPage, taxInclusiveStore,
                userInfo, taxCalculated, taxInclusiveShippingCountry, enableVATCalculation),
            displayWholesalePrice: this.getWholesalePriceConfig(displayPage, taxInclusiveStore,
                userInfo, taxCalculated, taxInclusiveShippingCountry, enableVATCalculation,isJoinFbo),
            displayBaseWholesalePrice: this.getBaseWholesalePriceConfig(displayPage, taxInclusiveStore,
                userInfo, taxCalculated, taxInclusiveShippingCountry, enableVATCalculation,isJoinFbo),
            displayComputedTaxInclusivePrice: this.getComputedTaxInclusivePriceConfig(displayPage, taxInclusiveStore,
                userInfo, taxCalculated, taxInclusiveShippingCountry, enableVATCalculation),

        };
        return displayPriceConfig;
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/member-display-price-config.service.ts